<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>协议</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column sortable prop="id" label="ID" width="60" show-overflow-tooltip></el-table-column>
            <el-table-column prop="agreement_title" label="协议标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="register_title" label="注册协议标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="secret_title" label="隐私协议标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="teach_title" label="教程标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="channel_type" label="所属通道" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div>{{scope.row.channel_type == 'jsws' ? '锦胜雾森': '凌阳高空'}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteCourses(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <!--<Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>-->

        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="协议标题" prop="serial">
                    <el-input size="small" v-model="editForm.agreement_title" auto-complete="off"
                              placeholder="协议标题"></el-input>
                </el-form-item>
                <el-form-item label="协议与声明内容" prop="agreement_content">
                    <quill-editor ref="text" v-model="editForm.agreement_content" class="myQuillEditor"
                                  :options="editorOption"/>
                </el-form-item>
                <el-form-item label="注册协议标题" prop="register_title">
                    <el-input size="small" v-model="editForm.register_title" auto-complete="off"
                              placeholder="注册协议标题"></el-input>
                </el-form-item>
                <el-form-item label="协议与声明内容" prop="register_content">
                    <quill-editor ref="text" v-model="editForm.register_content" class="myQuillEditor"
                                  :options="editorOption"/>
                </el-form-item>
                <el-form-item label="隐私协议标题" prop="secret_title">
                    <el-input size="small" v-model="editForm.secret_title" auto-complete="off"
                              placeholder="隐私协议标题"></el-input>
                </el-form-item>
                <el-form-item label="隐私协议内容" prop="secret_content">
                    <quill-editor ref="text" v-model="editForm.secret_content" class="myQuillEditor"
                                  :options="editorOption"/>
                </el-form-item>
                <el-form-item label="教程标题" prop="teach_title">
                    <el-input size="small" v-model="editForm.teach_title" auto-complete="off"
                              placeholder="教程标题"></el-input>
                </el-form-item>
                <el-form-item label="教程内容" prop="teach_content">
                    <quill-editor ref="text" v-model="editForm.teach_content" class="myQuillEditor"
                                  :options="editorOption"/>
                </el-form-item>
                <el-form-item label="所属通道" prop="channel_type">
                    <el-radio v-model="editForm.channel_type" label="jsws">锦胜雾森</el-radio>
                    <el-radio v-model="editForm.channel_type" label="lygk">凌阳高空</el-radio>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    import {agreement, deleteAgreement, saveAgreement} from "../../api/userMG";
    import Quill from 'quill'
    import {quillEditor} from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import {ImageExtend} from 'quill-image-extend-module'

    Quill.register('modules/ImageExtend', ImageExtend)

    export default {
        data() {
            return {
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                operatorVisible: false, //控制操作员页面显示与隐藏
                title: '添加/修改协议',
                formInline: {
                    page: 1,
                    limit: 10,
                    pageSize: 10
                },
                editForm: {
                    id: 0,
                    agreement_title: '',
                    register_title: '',
                    secret_title: '',
                    teach_title: '',
                    agreement_content: '',
                    register_content: '',
                    secret_content: '',
                    teach_content: '',
                    channel_type: 'jsws',
                },
                rules: {
                    agreement_title: [
                        {required: true, message: '请输入协议标题', trigger: 'blur'}
                    ],
                    register_title: [
                        {required: true, message: '请输入注册协议标题', trigger: 'blur'}
                    ],
                    secret_title: [
                        {required: true, message: '请输入隐私协议标题', trigger: 'blur'}
                    ],
                    teach_title: [
                        {required: true, message: '请输入教程标题', trigger: 'blur'}
                    ],
                    agreement_content: [
                        {required: true, message: '请输入协议与声明内容', trigger: 'blur'}
                    ],
                    register_content: [
                        {required: true, message: '请输入用户注册协议内容', trigger: 'blur'}
                    ],
                    secret_content: [
                        {required: true, message: '请输入用户隐私协议内容', trigger: 'blur'}
                    ],
                    teach_content: [
                        {required: true, message: '请输入教程内容', trigger: 'blur'}
                    ],
                    channel_type: [
                        {required: true, message: '请选择通道', trigger: 'blur'}
                    ],
                },
                listData: [], //用户数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                },
                editorOption: {
                    modules: {
                        ImageExtend: {
                            // 如果不作设置，即{}  则依然开启复制粘贴功能且以base64插入
                            name: "file", // 图片参数名
                            size: 3, // 可选参数 图片大小，单位为M，1M = 1024kb
                            action: "/res/imgUpload", // 服务器地址, 如果action为空，则采用base64插入图片
                            // response 为一个函数用来获取服务器返回的具体图片地址
                            // 例如服务器返回{code: 200; data:{ url: 'baidu.com'}}
                            // 则 return res.data.url
                            response: res => {
                                return res.data;
                            },
                            headers: xhr => {
                                // 上传图片请求需要携带token的 在xhr.setRequestHeader中设置
                                xhr.setRequestHeader(
                                    "Authorization",
                                    this.getCookie("username")
                                        ? this.getCookie("username").token_type +
                                        this.getCookie("username").access_token
                                        : "Basic emh4eTp6aHh5"
                                );
                            }, // 可选参数 设置请求头部
                            sizeError: () => {
                            }, // 图片超过大小的回调
                            start: () => {
                            }, // 可选参数 自定义开始上传触发事件
                            end: () => {
                            }, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
                            error: () => {
                            }, // 可选参数 上传失败触发的事件
                            success: () => {
                            }, // 可选参数  上传成功触发的事件
                            change: (xhr, formData) => {
                                // xhr.setRequestHeader('myHeader','myValue')
                                // formData.append('token', 'myToken')
                            } // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
                        },
                        toolbar: {
                            container: [
                                ['bold', 'italic', 'underline', 'strike'],        //加粗，斜体，下划线，删除线
                                ['blockquote', 'code-block'],         //引用，代码块
                                [{'header': 1}, {'header': 2}],               // 标题，键值对的形式；1、2表示字体大小
                                [{'list': 'ordered'}, {'list': 'bullet'}],          //列表
                                [{'script': 'sub'}, {'script': 'super'}],      // 上下标
                                [{'indent': '-1'}, {'indent': '+1'}],          // 缩进
                                [{'direction': 'rtl'}],                         // 文本方向
                                [{'size': ['small', false, 'large', 'huge']}],  // 字体大小
                                [{'header': [1, 2, 3, 4, 5, 6, false]}],         //几级标题
                                [{'color': []}, {'background': []}],          // 字体颜色，字体背景颜色
                                [{'font': []}],         //字体
                                [{'align': []}],        //对齐方式
                                ['clean'],        //清除字体样式
                                ['image', 'video']        //上传图片、上传视频
                            ]
                        }
                    },
                },
            }
        },
        // 注册组件
        components: {
            Pagination,
            quillEditor
        },
        /**
         * 创建完毕
         */
        created() {
            this.getdata(this.formInline)
        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            getdata(parameter) {
                this.loading = true
                agreement(parameter).then(res => {
                    this.listData = res.data
                    this.loading = false
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.page = parm.currentPage
                this.formInline.limit = parm.pageSize
                this.formInline.pageSize = parm.pageSize
                this.getdata(this.formInline)
            },
            // 搜索事件
            search() {
                this.getdata(this.formInline)
            },
            //显示编辑界面
            handleEdit: function (row) {
                this.editFormVisible = true
                if (row != undefined) {
                    this.editForm = row
                }
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        saveAgreement(this.editForm)
                            .then(res => {
                                this.editFormVisible = false
                                this.loading = false
                                if (res.code == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '保存成功！'
                                    })
                                    this.getdata()
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: '保存失败！'
                                    })
                                }
                            })
                            .catch(err => {
                                this.editFormVisible = false
                                this.loading = false
                                this.$message.error('教程保存失败，请稍后再试！')
                            })
                    } else {
                        return false
                    }
                })
            },
            // 删除管理员
            deleteCourses(row) {
                this.$confirm('确定要删除吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteAgreement({id: row.id})
                        .then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '教程已删除!'
                                })
                                this.getdata(this.formInline)
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '教程删除失败!'
                                })
                            }
                        })
                        .catch(err => {
                            this.loading = false
                            this.$message.error('教程删除失败，请稍后再试！')
                        })
                })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            // 关闭编辑、增加弹出框
            closeOperator() {
                this.operatorVisible = false
            },
            // 关闭编辑、增加弹出框
            closeDialog(formName) {
                this.editFormVisible = false
                this.$refs[formName].resetFields()
            }
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }
</style>







// WEBPACK FOOTER //
// src/views/protocal/protocal.vue